/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Big_Jackdaw_VentInputs */

const fr_clear_big_jackdaw_vent = /** @type {(inputs: Clear_Big_Jackdaw_VentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie supprimée`)
};

/**

* @param {Clear_Big_Jackdaw_VentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clear_big_jackdaw_vent = /** @type {((inputs?: Clear_Big_Jackdaw_VentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Big_Jackdaw_VentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clear_big_jackdaw_vent(inputs)
});